{
  "changeCurrency": "Change display currency",
  "approx": "≈ {value}",
  "disclaimer": "Converted prices are estimates. All bids and payments are in GBP.",
  "currencies": {
    "gbp": "British Pound",
    "hkd": "Hong Kong Dollar",
    "jpy": "Japanese Yen",
    "usd": "US Dollar",
    "eur": "Euro"
  }
}
